import React from 'react';
import {useState} from 'react';

import Header from '../../../components/Header';
import MFooter from '../../../components/MFooter'

import {useFetch} from '../../../hooks/useFetch'
import Loading  from '../../../components/Loading'

import {
    PContent,
    Pbloco,
    Alternativa,

} from './styled'

function Home () {
  return (
    <>
        <Header/>
        <div style={{minHeight: "450px"}}><Content/></div>
        <MFooter/>
    </>
  );
}

export default Home;

function Content({props}){
    const {data:perguntas} = useFetch("/perguntas");
    if (!perguntas) return  <Loading/>

    console.log(perguntas);
    return (
        <PContent>
            {perguntas.map((pergunta,i)=><PerguntaBlock pergunta={pergunta} key={pergunta.id} p={i}/>)}
        </PContent>
    )
}

function PerguntaBlock({p,pergunta}){
    const {/*id,*/ autor,titulo, correta, quiz_id} = pergunta
    const op = [ "alt_a", "alt_b", "alt_c", "alt_d", "alt_e",];

    const [expandir, setExpandir] = useState(false);
    const fnA = ()=>setExpandir(x=>true);
    return (
        <Pbloco expandir={expandir}>

            <h1 onClick={fnA}>{p+1} - {titulo} </h1>
            <div>
                {/* <div onClick={fnA}>{`ID: ${id} || Autor: ${autor}  ||  quiz_id: ${quiz_id}`}</div> */}
                <div onClick={fnA}>{`Autor: ${autor}  ||  quiz_id: ${quiz_id}`}</div>
                <i onClick={()=>setExpandir(x=>!x)} className={`fi-rr-angle-${!expandir?"down":"up"}`}/>
            </div>
            {!!expandir&&<div> {
                op.map((x,i)=><Alternativa correta={x===correta} key={i}>
                    {pergunta[x]}
                </Alternativa>)
            } </div>}
        </Pbloco>
    )
}
